/* IX NOVA — official brand logo (uses the new gold serif "N" master icon).
 *
 *  Previously this was a blue/silver SVG. That mark was replaced by the
 *  hand-designed gold serif Didone "N" on obsidian (rejected-icon fix,
 *  Apple 2.3.8). Since the artwork is now painterly + metallic, an SVG
 *  reproduction wouldn't do it justice — we render the PNG directly.
 *  Every `<NovaLogo size={N}>` call site downsamples the same source of
 *  truth (public/nova-app-icon-1024.png), so the brand is identical
 *  everywhere: header, splash, login, app-store icon, PWA, favicon.
 *
 *  Variants:
 *    NovaLogo    — icon mark only, square, rounded on demand
 *    NovaLockup  — mark + "IX NOVA" wordmark + optional tagline
 */
import React from "react";

const ICON_SRC = "/nova-app-icon-1024.png";

/** Icon mark only. */
export function NovaLogo({ size = 32, withBg = false, className, alt = "IX NOVA", ...rest }) {
  const style = {
    width: size,
    height: size,
    display: "inline-block",
    objectFit: "cover",
    borderRadius: withBg ? Math.round(size * 0.22) : 0,
    // A hair of edge softness so the mark integrates when scaled below 40px.
    imageRendering: size < 48 ? "auto" : "high-quality",
    // Prevent any accidental drag ghost on desktop
    userSelect: "none",
    WebkitUserDrag: "none",
  };
  return (
    <img
      src={ICON_SRC}
      alt={alt}
      draggable="false"
      className={className}
      style={style}
      {...rest}
    />
  );
}

/** Logo + "IX NOVA" wordmark stacked. Used on welcome / splash / login. */
export function NovaLockup({ size = 120, tagline = false, className }) {
  return (
    <div
      className={className}
      style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 12 }}
    >
      <NovaLogo size={size} />
      <div
        style={{
          fontFamily: "'Fraunces', 'Playfair Display', Georgia, serif",
          fontWeight: 400,
          letterSpacing: "0.34em",
          fontSize: Math.round(size * 0.20),
          color: "var(--gold, #e8d3b9)",
        }}
      >
        IX NOVA
      </div>
      {tagline && (
        <div
          style={{
            fontSize: Math.round(size * 0.085),
            letterSpacing: "0.22em",
            color: "rgba(232, 211, 185, 0.62)",
            textTransform: "uppercase",
            marginTop: 2,
          }}
        >
          AI Personal Coach
        </div>
      )}
    </div>
  );
}

export default NovaLogo;
